import React from "react";
import { useNavigate } from "react-router-dom";
export var BackButton = function () {
    var navigate = useNavigate();
    return (React.createElement("button", { onClick: function () { return navigate(-1); }, className: "text-white hover:text-black-400 font-N7 whitespace-pre pt-[64px] w-fit" }, "<   Back"));
};
